import { Box, Button } from '@mui/material';
import { DataGrid, GridAddIcon, type GridColDef } from '@mui/x-data-grid';
import { Outlet } from 'react-router';

import PageBaseLayout from '../layouts/PageBaseLayout';
import { useEffect, useState } from 'react';
import { supabase } from '../supabase-client';
import type { MerchantTransaction } from '../models/types';
import useBackdrop from '../hooks/useBackdrop';
import useSnackbar from '../hooks/useSnackbar';
import StatCard from '../components/StatCard';
import useDialog from '../hooks/useDialog';
import { calculateBalanceFromTransactions } from '../utils';
import TopUpBrandBalanceDialog from '../components/TopUpBrandBalanceDialog';

export default function BrandTransactions() {
  const backdrop = useBackdrop();
  const snackbar = useSnackbar();
  const dialog = useDialog();
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState<MerchantTransaction[]>([
    // {
    //   id: 1,
    //   merchant_id: 0,
    //   amount: 0,
    //   created_at: new Date().toISOString(),
    //   type: 'debit',
    //   reason_id: 'ABC123',
    //   remarks: '',
    // },
  ]);
  const columns: GridColDef<MerchantTransaction>[] = [
    {
      field: 'id',
      headerName: 'ID',
      width: 30,
    },
    {
      field: 'merchant_id',
      headerName: 'Brand ID',
      width: 100,
      type: 'number',
    },
    {
      field: 'email',
      headerName: 'Admin Email',
      type: 'string',
      width: 200,
    },
    {
      field: 'created_at',
      headerName: 'Created',
      type: 'dateTime',
      valueGetter: (value) => new Date(value),
      width: 180,
    },
    {
      field: 'type',
      headerName: 'Type',
      width: 100,
    },
    {
      field: 'reason_id',
      headerName: 'Reason ID',
      width: 180,
      type: 'string',
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 100,
      type: 'number',
      renderCell: (param) =>
        `${param.row.type === 'debit' ? '-' : ''}${param.value}`,
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      width: 300,
      type: 'string',
    },
  ];

  const getData = async () => {
    backdrop.handleBackdropOpen();

    try {
      const { data, error } = await supabase
        .schema('admin_backend')
        .from('brand_transactions_view')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching brand transactions:', error);
        throw error;
      }

      const balanceResponse = await supabase
        .schema('admin_backend')
        .from('brand_balances')
        .select('*')
        .single();

      if (balanceResponse.error) {
        console.error('Error fetching brand balance:', error);
        throw error;
      }

      const balance = balanceResponse.data.balance;
      setBalance(balance);

      setTransactions(data);
    } catch (error) {
      const errorCast = error as Error;
      console.error(errorCast.stack);
      snackbar.handleSnackbarOpen(errorCast.message, 'error');
    }

    backdrop.handleBackdropClose();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <PageBaseLayout
      title="Transactions"
      actions={
        <Button
          startIcon={<GridAddIcon />}
          size="small"
          variant="contained"
          onClick={() => {
            dialog.handleDialogOpen(
              <TopUpBrandBalanceDialog />,
              'Brand Balance Top-Up',
            );
          }}>
          Brand Balance Top-Up
        </Button>
      }>
      <Box>
        <br />
        <StatCard
          backgroundColour={balance < 0 ? 'red' : undefined}
          title="Balance"
          value={`$${balance.toFixed(2)}`}
          interval=""
          trend="up"
          //   data={[
          //     200, 24, 220, 260, 240, 380, 100, 240, 280, 240, 300, 340, 320, 360,
          //     340, 380, 360, 400, 380, 420, 400, 640, 340, 460, 440, 480, 460,
          //     600, 880, 920,
          //   ]}
        />
      </Box>
      <br />
      <DataGrid columns={columns} rows={transactions} />
      <Outlet />
    </PageBaseLayout>
  );
}
